import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import bg from "./../../assets/images/CarouselHome/bg.webp";
import { FaPhoneAlt } from "react-icons/fa";
import { Typography } from "@material-tailwind/react";
import { Link } from "react-router-dom";
// import LanguageBar from "../common/LanguageBar";
import ichName from '../../assets/images/IchName/logoICH.svg'
// import MerryChristmas from "../common/MerryChristmas";
import ReactFlagsSelect from "react-flags-select";
import { LanguagesIcon } from "lucide-react";

interface HomeBackgroundProps {
  changeLanguage: (code: string) => void;
  currentLang: string;
}


const variants = {
  active: {
      backgroundColor: "#f00"
  },
  inactive: {
    backgroundColor: "#fff",
    transition: { duration: 2 }
  }
}


const HomeBackground: React.FC<HomeBackgroundProps> = ({ changeLanguage, currentLang }) => {
  const textRef = useRef<HTMLParagraphElement>(null);

  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [country, setCountry] = useState("")

  useEffect(() => {
    if (selectedLanguage === "LK") {
      changeLanguage("si")
    } else if (selectedLanguage === "US") {
      changeLanguage("en")
    } else if (selectedLanguage === "DE") {
      changeLanguage("de")
    }
  }, [selectedLanguage])

  useEffect(() => {
    if (currentLang === "si") {
      setCountry("LK")
    } else if (currentLang === "en") {
      setCountry("US")
    } else if (currentLang === "de") {
      setCountry("DE")
    }
  }, [currentLang])



  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <div className="flex flex-row items-center w-full bg-white ">
        {/* Background Image with Optimizations */}
        <div className="w-full">

          <div className="absolute z-20 w-full  mt-7 xl:px-28 px-6 hidden md:block">
            {/* <LanguageBar changeLanguage={changeLanguage} currentLang={currentLang} /> */}

            <div className="flex items-end justify-end ">
              <div className="flex flex-row items-center gap-1">
                <div className="text-sm text-white"><LanguagesIcon size={21}/></div>
                <div className="text-gray-800">
                  <ReactFlagsSelect
                    selected={country}
                    onSelect={(code) => setSelectedLanguage(code)}
                    countries={['US', 'LK', 'DE']}
                    customLabels={{ US: 'English', LK: 'Sinhala', DE: 'Deutsch' }}
                    showSelectedLabel={true}
                    selectedSize={15}
                    optionsSize={15}
                    className="flag-select text-gray-800"
                    selectButtonClassName="!p-0 !border-0 !outline-none focus:!ring-0 focus:!ring-offset-0 !bg-transparent text-white"
                  />
                </div>
              </div>
            </div>
          </div>



          <div className="relative h-[80vh] min-h-[300px] max-h-[300px] md:min-h-[500px] md:max-h-[600px] lg:min-h-[650px] lg:max-h-[600px] xl:min-h-[540px] xl:max-h-[670px] w-full">
            <div className="absolute inset-0 bg-gray-200 animate-pulse "></div>
            <picture>
              <source srcSet={`${bg}?format=avif`} type="image/avif" />
              <source srcSet={`${bg}?format=webp`} type="image/webp" />
              <img
                src={bg}
                loading="eager"
                alt="Ceylon Hospital modern healthcare facility"
                width={1600}
                height={900}
                className=" inset-0 w-full h-full object-cover z-10"
                decoding="async"
                style={{
                  contentVisibility: "auto",
                  transition: "opacity 0.5s ease",
                  opacity: 0,
                }}
                onLoad={(e) => {
                  e.currentTarget.style.opacity = "1";
                  const placeholder = document.querySelector(
                    ".animate-pulse"
                  ) as HTMLElement | null;
                  if (placeholder) placeholder.style.display = "none";
                }}
              />
            </picture>
            <div className="absolute inset-0 bg-gradient-to-l from-blue-900/100 to-transparent" />
          </div>
        </div>

        {/* Hero Content */}
        <div className="absolute grid w-full items-center">
          <div className="mx-auto flex flex-col gap-4">
            <motion.div
            
              variants={variants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.7 }}
              className="w-full"
            >
              <div className="text-center text-white Blinker-SemiBold">
                <p
                  ref={textRef}
                  className="xl:text-5xl lg:text-4xl md:text-4xl text-2xl px-10"
                  aria-label="Our mission: We Take Care Our Patients' Health"
                >
                  We Take Care Our Patients' Health
                </p>
              </div>
            </motion.div>

            <motion.div
              variants={variants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.7 }}
              className="w-full flex flex-col gap-4"
            >
              <div className="w-full md:block hidden">
                <div className="flex  justify-center">
                  <Link
                    to="/book-appointment"
                    aria-label="Book an appointment at Ceylon Hospital"
                  >
                    <button
                      className="Blinker-SemiBold bg-green-600 hover:bg-green-700 font-bold text-white text-md md:text-lg lg:text-2xl py-3 px-12 lg:px-20 rounded-md transition-all duration-200 hover:shadow-md active:scale-95"
                      tabIndex={0}
                    >
                      Book an Appointment
                    </button>
                  </Link>
                </div>
              </div>

              <Typography
                placeholder=""
                variant="lead"
                color="white"
                className="Poppins-Light text-center w-full Blinker-Regular lg:text-md text-md px-10 leading-tight"
              >
                From Healing a Community to Transforming a Nation.
              </Typography>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <div className="w-full">
        {/* Top Gradient */}
        <div className="w-full h-2 bg-gradient-to-r from-green-600 via-yellow-500 to-orange-500"></div>
        {/* Footer Content */}
        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 w-full bg-white shadow-lg">
          {/* Hospital Logo */}
          <div className="p-4 flex flex-col items-center justify-center border-r border-gray-200">
            {/* <h1
              className="Blinker-Bold text-4xl text-green-600 mb-2"
              aria-label="Ceylon Hospital"
            >
              Ceylon Hospital
            </h1> */}
            <div>
              {/* <MerryChristmas /> */}
              <img src={ichName} alt="Ceylon Hospital" width={300} height={300} />
            </div>
          </div>

          {/* Address */}
          <div className="p-4 flex items-center text-center justify-center border-r border-gray-200 bg-gray-50">
            <div>
              <p className="Blinker-SemiBold text-green-800 text-xl mb-2">
                Our Location
              </p>
              <address className="Blinker-Regular text-gray-700 leading-tight not-italic">
                No.228/1, Asiri Mawatha
                <br />
                Kandy Road, Yakkala
                <br />
                Gampaha, Sri Lanka.
              </address>
            </div>
          </div>

          {/* Description */}
          <div className="p-4 flex items-center justify-center border-r border-gray-200 bg-gradient-to-b from-green-100 to-white">
            <div>
              <p className="Blinker-Bold text-green-700 text-2xl mb-3 text-center">
                Ayurvedic Excellence
              </p>
              <p className="Blinker-Light text-gray-600 text-center">
                Traditional healing with modern care
              </p>
            </div>
          </div>

          {/* Contact */}
          <div className="p-4 flex flex-col items-center justify-center bg-gradient-to-b from-orange-50 to-white">
            <div className="text-center">
              <p className="Blinker-SemiBold text-orange-600 text-xl mb-2">
                Need Help?
              </p>
              <a
                href="tel:+94712509898"
                className="Blinker-Bold text-gray-800 text-2xl mb-1 hover:text-orange-600 transition-colors"
                aria-label="Call us at +94 71 250 9898"
              >
                +94 71 250 9898
              </a>
              <p className="Blinker-Regular text-gray-600 text-sm">
                24/7 Emergency
              </p>

              <button
                className="mt-3 Blinker-SemiBold bg-[#c2410c] hover:bg-[#9a3412] text-white px-5 py-3 rounded-lg transition-colors shadow-md flex items-center gap-2 mx-auto"
                onClick={() => (window.location.href = "tel:+94712509898")}
                aria-label="Contact us by phone at +94 71 250 9898"
              >
                <FaPhoneAlt className="w-4 h-4" />
                Contact Us
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Gradient */}
        <div className="w-full h-3 bg-gradient-to-r from-orange-500 via-green-500 to-yellow-400"></div>
      </div>
    </div>
  );
};

export default HomeBackground;